import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-374f94e1")

_pushScopeId("data-v-374f94e1")
const _hoisted_1 = { class: "bold mb3" }
const _hoisted_2 = { class: "flex flex-wrap" }
const _hoisted_3 = { class: "bold mt3 mb1" }
const _hoisted_4 = { class: "bold mt3 mb1" }
const _hoisted_5 = { class: "bold mt3 mb1" }
const _hoisted_6 = { class: "bold mt3 mb1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_AdminPanelHeader = _resolveComponent("AdminPanelHeader")!
  const _component_Input = _resolveComponent("Input")!
  const _component_BaseBox = _resolveComponent("BaseBox")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_AdminPanelHeader, {
      title: _ctx.$t('common.settings')
    }, {
      default: _withId(() => [
        _createVNode(_component_Button, {
          class: "ml3",
          onClick: $setup.saveTeamBiddingConfigSettings
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_BaseBox, {
      class: "admin-panel-teambidding-settings",
      saving: $setup.saveLoading
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('funTeamBidding.settings.categories')), 1),
        _createVNode("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.openTriviaDatabaseCategories, (category) => {
            return (_openBlock(), _createBlock("div", {
              class: ["category my1 mr2", {
          'category--selected': $setup.checkIfCategorySelected(category.id)
        }],
              key: category,
              onClick: ($event: any) => ($setup.handleToggleCategory(category))
            }, _toDisplayString(_ctx.$t(`funTeamBidding.categories.${category?.label}`)), 11, ["onClick"]))
          }), 128))
        ]),
        _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('funTeamBidding.settings.moneyForStart')), 1),
        _createVNode("div", null, [
          _createVNode(_component_Input, {
            modelValue: $setup.funTeamBiddingSettings.teamMoneyForStart,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.funTeamBiddingSettings.teamMoneyForStart = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('funTeamBidding.settings.moneyTakenStartOfBidding')), 1),
        _createVNode("div", null, [
          _createVNode(_component_Input, {
            modelValue: $setup.funTeamBiddingSettings.moneyTakenForStartOfBidding,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.funTeamBiddingSettings.moneyTakenForStartOfBidding = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('funTeamBidding.settings.resetTime')), 1),
        _createVNode("div", null, [
          _createVNode(_component_Input, {
            modelValue: $setup.funTeamBiddingSettings.timeAfterBidInSeconds,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($setup.funTeamBiddingSettings.timeAfterBidInSeconds = $event))
          }, null, 8, ["modelValue"]),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('funTeamBidding.bidding.seconds')), 1)
        ]),
        _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('funTeamBidding.settings.maxDebt')), 1),
        _createVNode("div", null, [
          _createVNode(_component_Input, {
            modelValue: $setup.funTeamBiddingSettings.maxDebt,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ($setup.funTeamBiddingSettings.maxDebt = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["saving"])
  ], 64))
})